/** @jsxImportSource @emotion/react */
import ReduxToastr from "react-redux-toastr";
import * as organizationSelectors from "../organization/organizationSelectors";
import { useSelector } from "react-redux";
import TopBar from "./TopBar";
import { css } from "@emotion/react";
import { Outlet } from "react-router-dom";
import { Footer } from "./Footer";
import { NewAdminBanner } from "./NewAdminBanner";
import { config } from "../../config";

const containerStyle = css`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content; center;
`;

export const AppLayout = () => {
  const organizationUiSettings = useSelector(
    organizationSelectors.currentUISettings
  );
  const commonElements = (
    <>
      <ReduxToastr />
      <style>
        {`.btn-primary {`}
        {organizationUiSettings?.colorPrimaryContrast &&
          `color: ${organizationUiSettings.colorPrimaryContrast} !important;`}
        {organizationUiSettings?.colorPrimary &&
          `background-color: ${organizationUiSettings.colorPrimary} !important;`}
        {organizationUiSettings?.colorPrimary &&
          `border-color: ${organizationUiSettings.colorPrimary} !important;`}
        {`}`}

        {`.btn-primary:hover {`}
        {organizationUiSettings?.colorPrimaryHighlight &&
          `border-color: ${organizationUiSettings.colorPrimaryHighlight} !important;`}
        {`}`}
      </style>
    </>
  );

  return (
    <>
      {config.environment === "production" && <NewAdminBanner />}
      <div className="page-main">
        <TopBar />
        {commonElements}
      </div>
      <div css={containerStyle}>
        <Outlet />
      </div>
      <Footer />
    </>
  );
};
